import { http } from './config/config-receituario'
export default {
  listar: (token) => {
    return http.get('agronomos', {
      headers: {
        Authorization: token,
      },
    })
  },
  listarByFilter: (token, nome) => {
    return http.get(`agronomos/filter?nome=${nome}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  salvar: (token, agronomo) => {
    return http.post('agronomos', agronomo, {
      headers: {
        Authorization: token,
      },
    })
  },
  atualizarAgronomo: (token, agronomo) => {
    return http.put('agronomos/' + agronomo.id_agronomo, agronomo, {
      headers: {
        Authorization: token,
      },
    })
  },
  atualizarAssinaturaDigital: (token, id, data) => {
    return http.put(
      `agronomos/uploads/${id}`,
      { data },
      {
        headers: {
          Authorization: token,
        },
      }
    )
  },
  uploadDigitalCert: (token, data) => {
    return http.post(`agronomos/uploads-digital-cert`, data, {
      headers: {
        Authorization: token,
      },
    })
  },
  deleteAgronomo: (token, id) => {
    return http.delete('agronomos/' + id, {
      headers: {
        Authorization: token,
      },
    })
  },
  editarART: (id, token, data) => {
    return http.patch(`agronomos/${id}`, data, {
      headers: {
        Authorization: token,
      },
    })
  },
}
